import { cn } from "@wags/ui/ui-utils";
import { Fragment, type ReactNode } from "react";

export function Marquee<T>({
    items,
    itemKey,
    renderItem,
    durationSec,
    reverse,
    className,
}: {
    items: T[];
    itemKey: (item: T) => string;

    renderItem: (item: T, isClone: boolean) => ReactNode;
    durationSec: number;
    reverse?: boolean;

    className?: string;
}) {
    return (
        <div
            className={cn(
                // oxlint-disable-next-line shadcn/no-arbitrary-values -- one four-stop edge fade; the mask-x utilities build intersected gradient layers instead
                "group/mq relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_4%,black_96%,transparent)]",
                className,
            )}
        >
            <div
                // oxlint-disable-next-line shadcn/no-arbitrary-values -- paused animation-play-state has no Tailwind utility
                className="flex w-max will-change-transform animate-ticker [@media(hover:hover)]:group-hover/mq:[animation-play-state:paused] motion-reduce:animate-none"
                style={
                    {
                        "--ticker-duration": `${durationSec}s`,
                        "--ticker-direction": reverse ? "reverse" : "normal",
                    } as React.CSSProperties
                }
            >
                {items.map((item) => (
                    <Fragment key={`${itemKey(item)}-original`}>
                        {renderItem(item, false)}
                    </Fragment>
                ))}
                {items.map((item) => (
                    <Fragment key={`${itemKey(item)}-clone`}>
                        {renderItem(item, true)}
                    </Fragment>
                ))}
            </div>
        </div>
    );
}
